import React, { useEffect, useState } from 'react';
import TextArea from '../../inputs/textarea/textarea';
import { Controller } from 'react-hook-form';
import { FormProps } from '../../../shared/interfaces/form';

interface FormTextareaProps {
  item: FormProps;
  index: number;
  baseId: string;
  errors: any;
  control: any;
  isDisabled: boolean;
  setValue: (name: string, value: any) => void;
  getValues: (name?: string | string[]) => any;
}

const FormTextarea = ({
  item,
  index,
  baseId,
  errors,
  control,
  isDisabled,
  setValue,
  getValues
}: FormTextareaProps) => {
  const [ isDisabledTextarea, setIsDisabledTextarea ] = useState(false);  
  
  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>, onChange: any) => {
    const newValue = e.target.value;
    onChange(newValue);
    
    if (item.name === 'description') {
    }
  };

  useEffect(() => {
      const page = window.location.hash.split('/')[1];
  
      if(page.toLocaleLowerCase().includes('list')) {
        setIsDisabledTextarea(true);
      }
  
    }, []);
  
  const textareaProps = {
    placeholder: item.placeholder,
    error: errors[item.name]?.message,
    disabled: isDisabled || isDisabledTextarea,
    multiline: true,
    rows: item.minRows || 4,
  };
  
  return (
    <Controller
      key={`textarea-${index}-${baseId}`}
      name={item.name}
      control={control}
      defaultValue={item.value || ''}
      rules={item.rules}
      render={({ field }) => (
        <TextArea
          {...textareaProps}
          value={field.value}
          onChange={(e) => handleTextareaChange(e as unknown as React.ChangeEvent<HTMLTextAreaElement>, field.onChange)}
          onBlur={field.onBlur}
          name={field.name}
        />
      )}
    />
  );
};

export default FormTextarea;